'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTtsUrl = exports.getStartedCmsUrlPublic = exports.getPublicSiteDomain = exports.getBundledOffer = exports.getGAClassName = exports.getHubsSignupCTA = exports.getHubsSignupUrl = undefined;

var _merchToSignupStringM;

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchIds = _interopRequireWildcard(_MerchandiseIds);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _Editions = require('self-service-api/constants/Editions');

var _BundledOffers = require('pricing-pages-unified-ui/constants/BundledOffers');

var _NonMerchandiseIdProducts = require('pricing-pages-unified-ui/constants/NonMerchandiseIdProducts');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// (may 8, 2019) cta documentation:
// https://docs.google.com/spreadsheets/d/1BHY9NGG6e41cna8s31RnxY1Sn0I7kNVBzzwuAxVd2D0/edit?ts=5cd1f219#gid=1017927284
var getHubsSignupUrl = exports.getHubsSignupUrl = function getHubsSignupUrl(_ref) {
  var merchandiseId = _ref.merchandiseId,
      nonMerchandiseIdProduct = _ref.nonMerchandiseIdProduct;
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '' + window.location.hostname + window.location.pathname;

  // Strip query params from this URL
  var url = encodeURI(baseUrl.split('?')[0]);

  if (merchandiseId) {
    var edition = _ImmutableMerchandiseIdMap2.default[merchandiseId].edition;
    var editionToAppend = [_Editions.STARTER, _Editions.PROFESSIONAL, _Editions.ENTERPRISE].indexOf(edition) > -1 ? edition : undefined;

    if (editionToAppend) {
      url = url + '/' + edition;
    }
  } else if (nonMerchandiseIdProduct) {
    var _nonMerchProductToEdi;

    var nonMerchProductToEdition = (_nonMerchProductToEdi = {}, _defineProperty(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_STARTER, _Editions.STARTER), _defineProperty(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_PROFESSIONAL, _Editions.PROFESSIONAL), _defineProperty(_nonMerchProductToEdi, _NonMerchandiseIdProducts.SUITE_ENTERPRISE, _Editions.ENTERPRISE), _nonMerchProductToEdi);

    var _edition = nonMerchProductToEdition[nonMerchandiseIdProduct];
    if (_edition) {
      url = url + '/' + _edition;
    }

    if (nonMerchandiseIdProduct === _NonMerchandiseIdProducts.BUNDLE) {
      // Pass whole url (including query params) for bundles
      url = encodeURI(baseUrl);
    }
  }

  return url;
};

var merchToSignupStringMap = (_merchToSignupStringM = {}, _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_CRM, 'crm'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_STARTER_EMAIL, 'marketingstarter'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_PROFESSIONAL, 'marketingpro'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_MARKETING_ENTERPRISE, 'marketingenterprise'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_SALES_STARTER, 'salesstarter'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_SALES_PROFESSIONAL, 'salespro'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_SALES_ENTERPRISE, 'salesenterprise'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_SERVICE_STARTER, 'servicestarter'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_SERVICE_PROFESSIONAL, 'serviceprofessional'), _defineProperty(_merchToSignupStringM, MerchIds.PRODUCT_SERVICE_ENTERPRISE, 'serviceenterprise'), _defineProperty(_merchToSignupStringM, MerchIds.ADDON_CMS, 'cms'), _merchToSignupStringM);
// hubs_signup-cta can be derived from sourceId and the
// merchId/nonMerchandiseIdProduct so we centralize it here
// rather than having each purchase motion explicitly define it
var getHubsSignupCTA = exports.getHubsSignupCTA = function getHubsSignupCTA(ctaType, // tts, buy, trial
sourceId, merchandiseId, nonMerchandiseIdProduct) {
  var resolvedProductIdentifier = void 0;
  var resolvedSourceIdentifier = void 0;

  if (!merchandiseId && !nonMerchandiseIdProduct) {
    throw new Error('need one of merchandiseId or nonMerchandiseIdProduct');
  }

  if (ctaType === 'buy') {
    var sourceParts = sourceId.split('-');
    resolvedSourceIdentifier = sourceParts[0] + '-buy' + sourceParts[1];
  } else {
    resolvedSourceIdentifier = sourceId;
  }

  if (merchandiseId) {
    resolvedProductIdentifier = merchToSignupStringMap[merchandiseId];
    if (!resolvedProductIdentifier) {
      throw new Error('unrecognized merchandiseId (' + merchandiseId + ') for hubs signup cta');
    }
  } else {
    resolvedProductIdentifier = nonMerchandiseIdProduct;
  }
  return resolvedProductIdentifier + '-' + resolvedSourceIdentifier;
};

// This function exists to simply wrap classNames so we are more aware that
// they are necessary for Google Analytics tracking and remove them accidentally
var getGAClassName = exports.getGAClassName = function getGAClassName(gaTrackingClassname) {
  return gaTrackingClassname;
};

var getBundledOffer = exports.getBundledOffer = function getBundledOffer(merchId, promotion, nonMerchandiseIdProduct) {
  var promotionId = promotion && promotion.eligiblePromotion;

  if (promotionId && _BundledOffers.promotionalBundleOffers[promotionId]) {
    return _BundledOffers.promotionalBundleOffers[promotionId][merchId];
  }

  if (nonMerchandiseIdProduct) {
    return _BundledOffers.standardBundleOffers[nonMerchandiseIdProduct] || null;
  }

  return _BundledOffers.standardBundleOffers[merchId] || null;
};

// need to keep a check on this - not sure if will be accurate for all links
var getPublicSiteDomain = exports.getPublicSiteDomain = function getPublicSiteDomain() {
  var localeToUrl = {
    en: 'https://www.hubspot.com',
    de: 'https://www.hubspot.de',
    es: 'https://www.hubspot.es',
    pt: 'https://br.hubspot.com',
    fr: 'https://www.hubspot.fr',
    ja: 'https://www.hubspot.jp'
  };

  var url = localeToUrl[(0, _getLang2.default)()];
  if (!url) {
    throw new Error('unknown localeToUrl mapping for lang: ' + (0, _getLang2.default)() + ', domain: public');
  }

  return url;
};

var getStartedCmsUrlPublic = exports.getStartedCmsUrlPublic = function getStartedCmsUrlPublic() {
  var publicSiteDomain = getPublicSiteDomain();
  return publicSiteDomain + '/products/marketing/content-management-system/get-started';
};

// TODO: if we ever add a language it'd be very easy to forget to update here...s ome unit test or something
// would be good.
var getTtsUrl = exports.getTtsUrl = function getTtsUrl() {
  var localeToUrl = {
    en: 'https://offers.hubspot.com/contact-sales',
    de: 'https://offers.hubspot.de/contact-sales',
    es: 'https://offers.hubspot.es/contact-sales',
    pt: 'https://br.hubspot.com/ofertas/contact-sales',
    fr: 'https://offers.hubspot.fr/contact-sales',
    ja: 'https://offers.hubspot.jp/contact-sales'
  };

  var url = localeToUrl[(0, _getLang2.default)()];
  if (!url) {
    throw new Error('unknown localeToUrl mapping for lang: ' + (0, _getLang2.default)() + ', domain: offers');
  }

  return url;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/publicPageUrls.js
// module id = 39
// module chunks = 3 4 5